import { render } from "./ShareInfoDialog.vue?vue&type=template&id=3074064e&scoped=true&ts=true"
import script from "./ShareInfoDialog.vue?vue&type=script&lang=ts"
export * from "./ShareInfoDialog.vue?vue&type=script&lang=ts"

import "./ShareInfoDialog.vue?vue&type=style&index=0&id=3074064e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3074064e"]])

export default __exports__